export default __webpack_public_path__ + "static/media/test3.ca985aab.svg";